import { render, staticRenderFns } from "./editDraft.vue?vue&type=template&id=71363318&scoped=true"
import script from "./editDraft.vue?vue&type=script&lang=js"
export * from "./editDraft.vue?vue&type=script&lang=js"
import style0 from "./editDraft.vue?vue&type=style&index=0&id=71363318&prod&lang=css"
import style1 from "./editDraft.vue?vue&type=style&index=1&id=71363318&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71363318",
  null
  
)

export default component.exports